import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultApiConfig } from "./apiSettings";
import { WithPagination } from "./common.types";
import { ReportInterface } from "./reports.types";
import { $Object } from "types/object";
import { defaultQueryStringify } from "../libs";

export const reportsApi = createApi({
  ...defaultApiConfig,
  reducerPath: "reportsApi",
  tagTypes: ["Reports"],
  endpoints: (builder) => ({
    getReports: builder.query<WithPagination<ReportInterface>, $Object>({
      query: (params) => ({
        url: `admin/reports?${defaultQueryStringify(params)}`,
      }),
      providesTags: ["Reports"],
    }),
    updateReport: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `admin/reports/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Reports"],
    }),

    // Comment moderation, driven from the reports table. All three
    // invalidate "Reports" so the row re-renders with the new state
    // (hidden flag flipped, or the comment gone after a delete).
    hideComment: builder.mutation<unknown, number>({
      query: (id) => ({
        url: `admin/comments/${id}/hide`,
        method: "PATCH",
      }),
      invalidatesTags: ["Reports"],
    }),
    unhideComment: builder.mutation<unknown, number>({
      query: (id) => ({
        url: `admin/comments/${id}/unhide`,
        method: "PATCH",
      }),
      invalidatesTags: ["Reports"],
    }),
    deleteComment: builder.mutation<unknown, number>({
      query: (id) => ({
        url: `admin/comments/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Reports"],
    }),
  }),
});

export const {
  useGetReportsQuery,
  useUpdateReportMutation,
  useHideCommentMutation,
  useUnhideCommentMutation,
  useDeleteCommentMutation,
} = reportsApi;
